import {
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode,
  isAxiosError,
} from "axios";
import {
  type PutCommercialMonitoringAPIRequest,
  type PutCommercialMonitoringAPIResponse,
} from "@/features/commercialRegistrationMonitoring/types";
import { SendToTrackingService } from "@/api/handlers/errors";

/**
 * モニタリング登録を更新するAPIを実行する。
 * @param {AxiosInstance} apiClient
 * @param {PutCommercialMonitoringAPIRequest} requests
 */
export const PutCommercialMonitoringAPI = async (
  apiClient: AxiosInstance,
  requests: PutCommercialMonitoringAPIRequest
): Promise<PutCommercialMonitoringAPIResponse> => {
  const url = "/commercial-monitoring/";

  try {
    const response = await apiClient.put<PutCommercialMonitoringAPIResponse>(
      url,
      requests
    );

    return response.data;
  } catch (error) {
    if (
      isAxiosError<AxiosResponse>(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
